_ = require 'underscore'
pluginValidators = require 'lib/plugins/plugin-validators'
sandboxParams = require 'data/plugin-iframe-sandbox'
t = require('views/internal/teacup-with-helpers')('plugin_chrome')

renderAction = (action) ->
  target = if pluginValidators.isValidUrlForIframe(action.url) then action.url else '#'
  anchorProps =
    'data-index': action.index
    href: target
    rel: 'noreferrer nofollow noopener'
    target: target
    title: action.alt
  t.a '.plugin-chrome-header-action', anchorProps, ->
    t.span '.plugin-action-icon', { style: "background-image: url('#{ action.icon }');" }

module.exports = t.renderable (content) ->
  { url, height, context, accentColor, title, actions, fullscreen } = content
  if content.type != 'iframe'
    return
  if !accentColor? || !/^#[a-fA-F0-9]{6}$/.test(accentColor)
    accentColor = '#EDEFF0'

  validActions = _.chain(actions)
    .filter((a) -> pluginValidators.isValidUrlForImage(a.icon))
    .map((a) -> _.extend a, { index: actions.indexOf(a) })
    .groupBy('position')
    .value()

  leftActions = validActions.left?.slice(0, 3) || []
  rightActions = validActions.right?.slice(0, 1) || []

  if rightActions.length == 1
    leftActions = leftActions.slice(0, 2)

  t.div '.plugin-chrome-content', ->
    t.iframe '.plugin-iframe',
      allow: 'microphone; camera'
      sandbox: sandboxParams
      src: url
      style: t.stylify({ height: if !fullscreen then "#{ height }px" })



// WEBPACK FOOTER //
// ./app/scripts/views/templates/plugin_chrome.coffee